import { OrderRepository } from 'src/api/order_repository';
import type { DownloadReportResult } from 'src/api/order_repository';
import {
  OrderBaseFieldsFragment,
  SamdOrderDetailFieldsFragment,
} from 'src/types';
import { DistributionPlatform } from 'src/types/env';

export interface SamdOrderRepository extends OrderRepository<SamdOrderDetailFieldsFragment> {
  readonly _platform: DistributionPlatform.Samd;

  // Add SaMD specific methods here
  resubmit(
    order: SamdOrderDetailFieldsFragment,
  ): Promise<SamdOrderDetailFieldsFragment>;
  downloadSlideImage(fileId: string): Promise<string>;
  downloadClinicalDecisionSupport(
    orderId: string,
  ): Promise<DownloadReportResult>;
  downloadCombinedReport(orderId: string): Promise<DownloadReportResult>;
}

// Type guard for runtime checking
export function isSamdOrderRepository(
  repo: OrderRepository<OrderBaseFieldsFragment>,
): repo is SamdOrderRepository {
  return repo._platform === DistributionPlatform.Samd;
}
